import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Flex, Text } from '@chakra-ui/react';
import * as React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function LoadingSpinner(_ref) {
  var loadingText = _ref.loadingText,
    svgProps = _ref.svgProps,
    wrapperStyle = _ref.wrapperStyle;
  return _jsxs(Flex, _objectSpread(_objectSpread({
    "data-testid": 'loading-spinner'
  }, _objectSpread(_objectSpread({}, currentWrapperStyle), wrapperStyle)), {}, {
    children: [_jsxs("svg", _objectSpread(_objectSpread({
      xmlns: "http://www.w3.org/2000/svg",
      width: "80px",
      height: "80px",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      className: "uil-spin"
    }, svgProps), {}, {
      children: [_jsx("rect", {
        x: "0",
        y: "0",
        width: "100",
        height: "100",
        fill: "none",
        className: "bk"
      }), _jsxs("g", {
        transform: "translate(50 50)",
        children: [_jsx("g", {
          transform: "rotate(0) translate(34 0)",
          children: _jsxs("circle", {
            cx: "0",
            cy: "0",
            r: "8",
            fill: "#511e62",
            children: [_jsx("animate", {
              attributeName: "opacity",
              from: "1",
              to: "0.1",
              begin: "0s",
              dur: "1s",
              repeatCount: "indefinite"
            }), _jsx("animateTransform", {
              attributeName: "transform",
              type: "scale",
              from: "1.4",
              to: "1",
              begin: "0s",
              dur: "1s",
              repeatCount: "indefinite"
            })]
          })
        }), _jsx("g", {
          transform: "rotate(45) translate(34 0)",
          children: _jsxs("circle", {
            cx: "0",
            cy: "0",
            r: "8",
            fill: "#511e62",
            children: [_jsx("animate", {
              attributeName: "opacity",
              from: "1",
              to: "0.1",
              begin: "0.12s",
              dur: "1s",
              repeatCount: "indefinite"
            }), _jsx("animateTransform", {
              attributeName: "transform",
              type: "scale",
              from: "1.4",
              to: "1",
              begin: "0.12s",
              dur: "1s",
              repeatCount: "indefinite"
            })]
          })
        }), _jsx("g", {
          transform: "rotate(90) translate(34 0)",
          children: _jsxs("circle", {
            cx: "0",
            cy: "0",
            r: "8",
            fill: "#511e62",
            children: [_jsx("animate", {
              attributeName: "opacity",
              from: "1",
              to: "0.1",
              begin: "0.25s",
              dur: "1s",
              repeatCount: "indefinite"
            }), _jsx("animateTransform", {
              attributeName: "transform",
              type: "scale",
              from: "1.4",
              to: "1",
              begin: "0.25s",
              dur: "1s",
              repeatCount: "indefinite"
            })]
          })
        }), _jsx("g", {
          transform: "rotate(135) translate(34 0)",
          children: _jsxs("circle", {
            cx: "0",
            cy: "0",
            r: "8",
            fill: "#511e62",
            children: [_jsx("animate", {
              attributeName: "opacity",
              from: "1",
              to: "0.1",
              begin: "0.37s",
              dur: "1s",
              repeatCount: "indefinite"
            }), _jsx("animateTransform", {
              attributeName: "transform",
              type: "scale",
              from: "1.4",
              to: "1",
              begin: "0.37s",
              dur: "1s",
              repeatCount: "indefinite"
            })]
          })
        }), _jsx("g", {
          transform: "rotate(180) translate(34 0)",
          children: _jsxs("circle", {
            cx: "0",
            cy: "0",
            r: "8",
            fill: "#511e62",
            children: [_jsx("animate", {
              attributeName: "opacity",
              from: "1",
              to: "0.1",
              begin: "0.5s",
              dur: "1s",
              repeatCount: "indefinite"
            }), _jsx("animateTransform", {
              attributeName: "transform",
              type: "scale",
              from: "1.4",
              to: "1",
              begin: "0.5s",
              dur: "1s",
              repeatCount: "indefinite"
            })]
          })
        }), _jsx("g", {
          transform: "rotate(225) translate(34 0)",
          children: _jsxs("circle", {
            cx: "0",
            cy: "0",
            r: "8",
            fill: "#511e62",
            children: [_jsx("animate", {
              attributeName: "opacity",
              from: "1",
              to: "0.1",
              begin: "0.62s",
              dur: "1s",
              repeatCount: "indefinite"
            }), _jsx("animateTransform", {
              attributeName: "transform",
              type: "scale",
              from: "1.4",
              to: "1",
              begin: "0.62s",
              dur: "1s",
              repeatCount: "indefinite"
            })]
          })
        }), _jsx("g", {
          transform: "rotate(270) translate(34 0)",
          children: _jsxs("circle", {
            cx: "0",
            cy: "0",
            r: "8",
            fill: "#511e62",
            children: [_jsx("animate", {
              attributeName: "opacity",
              from: "1",
              to: "0.1",
              begin: "0.75s",
              dur: "1s",
              repeatCount: "indefinite"
            }), _jsx("animateTransform", {
              attributeName: "transform",
              type: "scale",
              from: "1.4",
              to: "1",
              begin: "0.75s",
              dur: "1s",
              repeatCount: "indefinite"
            })]
          })
        }), _jsx("g", {
          transform: "rotate(315) translate(34 0)",
          children: _jsxs("circle", {
            cx: "0",
            cy: "0",
            r: "8",
            fill: "#511e62",
            children: [_jsx("animate", {
              attributeName: "opacity",
              from: "1",
              to: "0.1",
              begin: "0.87s",
              dur: "1s",
              repeatCount: "indefinite"
            }), _jsx("animateTransform", {
              attributeName: "transform",
              type: "scale",
              from: "1.4",
              to: "1",
              begin: "0.87s",
              dur: "1s",
              repeatCount: "indefinite"
            })]
          })
        })]
      })]
    })), loadingText && _jsx(Text, {
      mt: "xl",
      children: loadingText
    })]
  }));
}
var currentWrapperStyle = {
  margin: {
    mobile: '2xl',
    sm: '0'
  },
  justifyContent: 'center',
  alignItems: 'center',
  direction: 'column'
};